export var HandlerRole;

(function (HandlerRole) {
  HandlerRole["SOURCE"] = "SOURCE";
  HandlerRole["TARGET"] = "TARGET";
})(HandlerRole || (HandlerRole = {}));


//////////////////
// WEBPACK FOOTER
// ./node_modules/dnd-core/dist/esm/interfaces.js
// module id = 826
// module chunks = 0